// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__FSDKM","imageUploader":"EGiftCard_imageUploader__2ZQ-g"};